import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as commonActions from "../../../../../actions/common.actions";
import AdminReferralCodes from "../components/AdminReferralCodes";
import {
  getReferralCodes,
  updateReferralCode,
  createReferralCode
} from "../../../../../actions/admin.actions";

const subHeader = () => {
  return {
    items: [
      {
        caption: "Project",
        url: `/admin/new/projects`
      },
      {
        caption: "Admin",
        url: `/admin/new/users`
      },
      {
        caption: "Referral Codes",
        url: `/admin/new/referral-codes`
      }
    ],
    activeItem: 2
  };
};

class AdminReferralCodesContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(subHeader());
    this.props.getReferralCodes();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.updatedCode !== nextProps.updatedCode ||
      this.props.referralCode !== nextProps.referralCode
    ) {
      this.props.getReferralCodes();
    }
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  render() {
    return (
      <AdminReferralCodes
        onSubmit={this.handleSubmit}
        referralCodes={this.props.referralCodes}
        updateReferralCode={this.props.updateReferralCode}
        createReferralCode={this.props.createReferralCode}
        loadingCodes={this.props.loadingCodes}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    referralCodes: state.admin.referralCodes.data,
    updatedCode: state.admin.updatedCode.data,
    referralCode: state.admin.referralCode.data,
    loadingCodes: state.admin.loadingCodes
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    getReferralCodes: () => dispatch(getReferralCodes()),
    updateReferralCode: (id, active) =>
      dispatch(updateReferralCode(id, active)),
    createReferralCode: () => dispatch(createReferralCode())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminReferralCodesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/new/referralCodes/containers/AdminReferralCodesContainer.js